import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Modal, Button } from '@mui/material';
import CountryDeleteModal from "./deleteModal";
import { tableDeleteButtonSx, tableViewButtonSx } from "../../styles/actionStyles";

export default function CountryManagementColum(props) {
  const navigate = useNavigate();
  const { setAlert, setOpenAlert, setResponseMsg, setLoading, getCountryData } = props;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const ALERT_DURATION = 2000;

  const alertClose = () => {
    setAlert('');
  };

  const handleOpenDeleteModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenDeleteModal(true);
  };

  const truncateText = (value, maxLength = 34) => {
    if (!value) return '-';
    return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
  };

  const countryManagementColumn = [
    {
      field: 'name',
      headerName: 'Country',
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
          {params.value || '-'}
        </Typography>
      ),
    },
    {
      field: 'regionName',
      headerName: 'Region',
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
          {params.value || '-'}
        </Typography>
      ),
    },
    {
      field: 'currencyCode',
      headerName: 'Currency',
      flex: 0.9,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
          {params.value || '-'}
        </Typography>
      ),
    },
    {
      field: 'timeZone',
      headerName: 'Timezone',
      flex: 1,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
          {truncateText(params.value, 28)}
        </Typography>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Added On',
      flex: 0.9,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        const dateOnly = params.value ? new Date(params.value).toISOString().split('T')[0] : '-';
        return (
          <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
            {dateOnly}
          </Typography>
        );
      },
    },
    {
      field: "actions",
      headerName: "Action",
      flex: 1.2,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: '100%' }}>
            <Button
              onClick={() => navigate(`/countryManagementView/${params.row.id}?type=edit`)}
              startIcon={<span className="material-symbols-rounded">visibility</span>}
              sx={tableViewButtonSx}
            >
              View
            </Button>

            <Button
              onClick={() => handleOpenDeleteModal(params.row.id)}
              startIcon={<span className="material-symbols-rounded">delete</span>}
              sx={tableDeleteButtonSx}
            >
              Delete
            </Button>
          </Box>

          <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
            <div>
              <CountryDeleteModal onClose={() => setOpenDeleteModal(false)} getCountryData={getCountryData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
            </div>
          </Modal>
        </>
      ),
    },
  ];

  return countryManagementColumn;
}
